module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rotage-box"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "box1 box"
  }, [_vm._v("CSS")]), _vm._v(" "), _c('div', {
    staticClass: "box2 box"
  }, [_vm._v("SMUI")]), _vm._v(" "), _c('div', {
    staticClass: "box3 box"
  }, [_vm._v("VUE")]), _vm._v(" "), _c('div', {
    staticClass: "box4 box"
  }, [_vm._v("Webpack")]), _vm._v(" "), _c('div', {
    staticClass: "box5 box"
  }, [_vm._v("Node")]), _vm._v(" "), _c('div', {
    staticClass: "box6 box"
  }, [_vm._v("HTML5")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-301dec62!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/index/RotageBox.vue
// module id = 321
// module chunks = 1 4